import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAccessToken } from '@dispatch/web/auth';
import { useIsAuthenticated } from '@azure/msal-react';
import { useGetNotNotifiedReports } from './UseGetNotNotifiedReports';

type ExportNotificationContextType = {
  setIsReportPollingEnabled: React.Dispatch<React.SetStateAction<boolean>>;
};

const ExportNotificationContext = createContext<
  ExportNotificationContextType | undefined
>(undefined);

export const ExportNotificationProvider: React.FC = ({ children }) => {
  const [isReportPollingEnabled, setIsReportPollingEnabled] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const isOnReportsPage = location.pathname === '/reports';
    if (isOnReportsPage) {
      setIsReportPollingEnabled(false);
    } else {
      setIsReportPollingEnabled(true);
    }
  }, [location.pathname]);

  const isAuthenticated = useIsAuthenticated();

  const { isAccessTokenSet } = useAccessToken();

  const isReady = isAuthenticated && isAccessTokenSet;

  useGetNotNotifiedReports(
    isReportPollingEnabled && isReady,
    setIsReportPollingEnabled
  );

  return (
    <ExportNotificationContext.Provider value={{ setIsReportPollingEnabled }}>
      {children}
    </ExportNotificationContext.Provider>
  );
};
export const useExportNotification = () => {
  const context = useContext(ExportNotificationContext);
  if (!context) {
    throw new Error(
      'useExportNotification must be used within an ExportNotificationProvider'
    );
  }
  return context;
};
